import {useEffect, useState} from 'react';
import ReactSelect from 'react-select'




const CustomOption = (props) => {
    const { data, innerProps, isDisabled, optionTemplate } = props
    innerProps.className = 'react-select-option'

    if(optionTemplate){
        return optionTemplate(props)
    }else{

        return !isDisabled ? (
            <div {...innerProps}>
                {data.label}
            </div>
        ) : null;
    }
}

const Select = (props) => {
    const [value, setValue] = useState(props.value || null);

    const name = props && props.name != undefined ? props.name : '';
    const disabled = props && props.disabled != undefined ? props.disabled : false;
    const isMulti = props && props.isMulti != undefined ? props.isMulti : false;
    const isSearchable = props && props.isSearchable != undefined ? props.isSearchable : false;
    const onFocus = props && props.onFocus != undefined ? props.onFocus : undefined
    const className = props && props.className != undefined ? props.className : 'input-sm'
    const placeholder = props && props.placeholder != undefined ? props.placeholder : 'Choose'
    const classNamePrefix = props && props.classNamePrefix != undefined ? props.classNamePrefix : 'input-sm'
    const hideSelectedOptions = props && props.hideSelectedOptions != undefined ? props.hideSelectedOptions : true
    const closeMenuOnSelect = props && props.closeMenuOnSelect != undefined ? props.closeMenuOnSelect : true




    useEffect(() => {

    }, [value])


    const handleChange = (values) => {
        setValue(values);

        if(typeof props.onChange == "function"){
            props.onChange(values)
        }

    }


    const handleBlur = (event) => {
        if(typeof props.onBlur == "function"){
            props.onBlur(value)
        }
    }


    const handleClear = () => {

    }

    return (
        <div className="Select">
            <ReactSelect
                name={name}
                value={value}
                options={props.options}
                onFocus={onFocus}
                isDisabled={disabled}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={placeholder}
                className={className}
                classNamePrefix={classNamePrefix}
                isClearable={props.isClearable != undefined ? props.isClearable : true}
                closeMenuOnSelect={closeMenuOnSelect}
                isSearchable={isSearchable}
                isMulti={isMulti}
                hideSelectedOptions={hideSelectedOptions}
                isOptionDisabled={(option) => option.disabled}
                components={{Option: (settings) => CustomOption({...settings, ...props})}}
            />
        </div>
    )
}



export default Select;